import { EXPIRED_SCREEN } from 'config/config';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  PaymentExpiredScreenContainer,
  PaymentExpiredScreenIcon,
  PaymentExpiredScreenMessage,
  PaymentExpiredScreenStatus,
  PaymentExpiredScreenStatusText,
  PaymentExpiredScreenWrapper,
} from './PaymentExpiredScreen.styles';

const { status, statusText, icon, description } = EXPIRED_SCREEN;

const PaymentExpiredScreen = memo(() => (
  <PaymentExpiredScreenContainer className="payment-expired-screen__container">
    <PaymentExpiredScreenWrapper>
      <PaymentExpiredScreenStatus className="payment-expired-screen__status">
        <FormattedMessage id={status} />
      </PaymentExpiredScreenStatus>
      <PaymentExpiredScreenStatusText className="payment-expired-screen__statusText">
        <FormattedMessage id={statusText} />
      </PaymentExpiredScreenStatusText>
      <PaymentExpiredScreenIcon className="payment-expired-screen__icon">
        <img src={icon} alt="icon" />
      </PaymentExpiredScreenIcon>
      <PaymentExpiredScreenMessage className="payment-expired-screen__message">
        <FormattedMessage id={description} />
      </PaymentExpiredScreenMessage>
    </PaymentExpiredScreenWrapper>
  </PaymentExpiredScreenContainer>
));

export default PaymentExpiredScreen;
